import {
  FETCH_LOCATIONS,
  CREATE_LOCATIONS
} from './mutations-types'
import firebase from '../../../firebase/main'
import helpers from '../../../helpers/functions'

export default {
  fetchLocations ({ commit }, payload) {
    return new Promise(resolve => {
      resolve(firebase.Locations.fetchLocations())
    })
      .then(res => {
        commit(FETCH_LOCATIONS, res)
        return true
      })
      .catch(err => helpers.handleError(err))
  },
  createLocations ({ commit }, payload) {
    return new Promise(resolve => {
      resolve(firebase.Locations.createLocations(payload))
    })
      .then(res => {
        commit(CREATE_LOCATIONS, {id: res.id, data: payload})
      })
  }
}
